import { render, staticRenderFns } from "./DiscountBanner.vue?vue&type=template&id=b61a909a&"
import script from "./DiscountBanner.vue?vue&type=script&lang=js&"
export * from "./DiscountBanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports